import * as React from 'react';
import clsx from 'clsx';
import { Transition } from 'react-transition-group';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Banner-module_banner__216HZ{display:block;padding:20px;border-radius:4px;overflow:hidden;color:var(--color-text-default)}.Banner-module_banner__216HZ.Banner-module_warning__1wLBE{background-color:var(--color-yellow-5);border:.5px solid var(--color-warning)}.Banner-module_banner__216HZ.Banner-module_critical__3kKnr{background-color:var(--color-surface-critical-subdued);border:.5px solid var(--color-border-critical-default)}.Banner-module_banner__216HZ.Banner-module_success__1_22_{background-color:var(--color-surface-success-subdued);border:.5px solid var(--color-green-50)}.Banner-module_banner__216HZ.Banner-module_informational__DZdSC{background-color:var(--color-surface-subdued);border:.5px solid var(--color-text-disabled)}.Banner-module_bannerHead__huuNs{display:flex;align-items:flex-start;justify-content:space-between}.Banner-module_bannerTitle__2_DlM{font-weight:600;font-size:var(--size-font-heading-sm);line-height:var(--size-line-height-text-heading-sm);display:flex}.Banner-module_bannerTitle__2_DlM:before{height:22px;width:22px;margin-right:6px}.Banner-module_banner__216HZ.Banner-module_warning__1wLBE .Banner-module_bannerTitle__2_DlM:before{content:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' fill='%23E39539'/%3E%3C/svg%3E\")}.Banner-module_banner__216HZ.Banner-module_critical__3kKnr .Banner-module_bannerTitle__2_DlM:before{content:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' fill='%23E02D38'/%3E%3C/svg%3E\")}.Banner-module_banner__216HZ.Banner-module_success__1_22_ .Banner-module_bannerTitle__2_DlM:before{content:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm3 0l5 5 9-9-1.41-1.42L10 14.17l-3.59-3.58L5 12z' fill='%234CA375'/%3E%3C/svg%3E\")}.Banner-module_banner__216HZ.Banner-module_informational__DZdSC .Banner-module_bannerTitle__2_DlM:before{content:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15v-6h2v6h-2zm0-10v2h2V7h-2z' fill='%2345474A'/%3E%3C/svg%3E\")}.Banner-module_bannerCloseIcon__TqvLm{border:none;background:transparent;width:22px;height:22px;padding:0;margin-left:8px}.Banner-module_bannerCloseIcon__TqvLm:after{display:inline-block;width:22px;height:22px;content:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z' fill='%2345474A'/%3E%3C/svg%3E\")}.Banner-module_bannerCloseIcon__TqvLm:hover{cursor:pointer}.Banner-module_bannerBody__1j-Qe{margin-top:12px;padding-right:32px}.Banner-module_noPadding__3QHdQ{padding:0}.Banner-module_bannerAction__eHD8j,.Banner-module_bannerDescription__3gAKA{font-weight:400;font-size:var(--size-font-body-small);line-height:var(--size-line-height-text-body-small);color:var(--color-text-subdued)}.Banner-module_bannerAction__eHD8j{margin-top:16px}.Banner-module_banner__216HZ button{background-color:transparent}";
var styles = {"banner":"Banner-module_banner__216HZ","warning":"Banner-module_warning__1wLBE","critical":"Banner-module_critical__3kKnr","success":"Banner-module_success__1_22_","informational":"Banner-module_informational__DZdSC","bannerHead":"Banner-module_bannerHead__huuNs","bannerTitle":"Banner-module_bannerTitle__2_DlM","bannerCloseIcon":"Banner-module_bannerCloseIcon__TqvLm","bannerBody":"Banner-module_bannerBody__1j-Qe","noPadding":"Banner-module_noPadding__3QHdQ","bannerDescription":"Banner-module_bannerDescription__3gAKA","bannerAction":"Banner-module_bannerAction__eHD8j"};
styleInject(css_248z);

var BannerDescription = function (_a) {
    var className = _a.className, children = _a.children, BannerDescriptionProps = __rest(_a, ["className", "children"]);
    return (React.createElement("div", __assign({ className: clsx(styles.bannerDescription, className) }, BannerDescriptionProps), children));
};

var BannerAction = function (_a) {
    var className = _a.className, children = _a.children, BannerActionProps = __rest(_a, ["className", "children"]);
    return (React.createElement("div", __assign({ className: clsx(styles.bannerAction, className) }, BannerActionProps), children));
};

var Banner = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.type, type = _b === void 0 ? 'informational' : _b, title = _a.title, _c = _a.closable, closable = _c === void 0 ? true : _c, onOpenStateChange = _a.onOpenStateChange, _d = _a.animationDuration, animationDuration = _d === void 0 ? 300 : _d, bannerProps = __rest(_a, ["className", "children", "type", "title", "closable", "onOpenStateChange", "animationDuration"]);
    var _e = React.useState(true), show = _e[0], setShow = _e[1];
    var isMounted = React.useRef(false);
    function handleClick(event) {
        var toggleBanner = event.target.dataset.toggleBanner;
        if (toggleBanner === 'true') {
            setShow(false);
        }
    }
    React.useEffect(function () {
        if (isMounted.current) {
            onOpenStateChange === null || onOpenStateChange === void 0 ? void 0 : onOpenStateChange(show);
        }
        else {
            isMounted.current = true;
        }
    }, [show, onOpenStateChange]);
    var defaultStyle = {
        transition: "opacity " + animationDuration + "ms ease-in-out",
        opacity: 1,
    };
    var transitionStyles = {
        entering: { opacity: 1 },
        entered: { opacity: 1 },
        exiting: { opacity: 0 },
        exited: { opacity: 0 },
        unmounted: { opacity: 0 },
    };
    return (React.createElement(Transition, { appear: true, in: show, timeout: animationDuration, unmountOnExit: true }, function (state) {
        return (React.createElement("div", __assign({ title: title, "data-banner-shown": show, className: clsx(styles.banner, styles[type], className), style: __assign(__assign({}, defaultStyle), transitionStyles[state]) }, bannerProps),
            React.createElement("div", { className: clsx(styles.bannerHead) },
                React.createElement("div", { className: clsx(styles.bannerTitle) }, title),
                closable && (React.createElement("button", { "data-toggle-banner": "true", "aria-label": "Close Banner", title: "Close Banner", onClick: handleClick, className: clsx(styles.bannerCloseIcon) }))),
            React.createElement("div", { onClick: handleClick, className: clsx(styles.bannerBody, !closable && styles.noPadding) }, children)));
    }));
};

export { Banner, BannerAction, BannerDescription };
